export { default as BasicInfo } from "./BasicInfo";
export { default as SocialInfo } from "./SocialInfo";
export { default as UserDetailsOptions } from "./UserDetailsOptions";
